export const LEGEND_HEIGHT = 40;
export const HEADING_HEIGHT = 30;
